<template>
    <div class="landing">
        <LandingContent ref="content" @submit="submitForm" :submitBtnAnimating="submitBtnAnimating">
            <template v-slot:result>
                <div v-if="formSubmitted !== null" class="alert" :class="formSubmitted ? 'alert-primary' : 'alert-warning'" role="alert">
                    {{ $t(formSubmitted ? "MessageSent" : "ErrorHappened") }}
                </div>
            </template>
        </LandingContent>
    </div>
</template>

<script>
import { utilityMixin } from "@/mixins/utilityMixin.js";
import firebaseApp from "@/database";

export default {
    mixins: [utilityMixin],
    components: { "LandingContent": () => import("@/components/LandingContent.vue") },
    data() {
        return {
            ipAddress: null,
            formSubmitted: null,
            submitBtnAnimating: false
        }
    },
    i18n: {
        messages: {
            en: {
                "MessageSent": "Message sent successful",
                "ErrorHappened": "Error occurred, try later or use e-mail"
            },
            ru: {
                "MessageSent": "Сообщение успешно отправлено",
                "ErrorHappened": "Произошла ошибка попробуйте позже или воспользуейтесь электронной почтой"
            }
        }
    },
    methods: {
        submitForm: function(event, email, message) {
            this.submitBtnAnimating = true;
            const self = this;
            return firebaseApp
                .database()
                .ref("__reports")
                .child((this.ipAddress || '0.0.0.0').split('.').join('_'))
                .push({
                    email: email,
                    message: message,
                    date: new Date().getTime() / 1000
                })
                .then(function() {
                    self.showMessage(true);
                    self.$refs.content.resetFeedback();
                })
                .catch(function(e) {
                    console.error(e);
                    self.showMessage(false);
                })
                .finally(() => {
                    self.submitBtnAnimating = false;
                });
        },
        showMessage(result) {
            this.formSubmitted = result;
            setTimeout(() => {
                this.formSubmitted = null;
            }, 5000);
        }
    },
    created() {
        var vm = this;
        if (this.ipAddress) return;
        fetch("https://api.ipify.org")
        .then(function(response) {
            return response.text();
        })
        .then(function(res) {
            console.log("IP address:", res);
            vm.ipAddress = res;
        })
        .catch(e => {
            console.error("Fetching IP address failed:", e);
        });
    }
}
</script>

<style>
</style>
